export const SpecialtyType = Object.freeze({
  OPHTHALMOLOGY: 1,
  ONCOLOGY_HEMATOLOGY: 2,
  RHEUMATOLOGY: 3,
  UROLOGY: 4,
  GASTROENTEROLOGY: 5,
  NEUROLOGY: 6,
  GYNECOLOGY: 7,
  PULMONOLOGY: 8,
  NEPHROLOGY: 9,
  IMMUNOLOGY: 10,
});
